import { AbstractControl, ValidatorFn } from '@angular/forms';

export function conditionalValidator(condition: () => boolean, validator: ValidatorFn): ValidatorFn {
    return (control: AbstractControl): { [key: string]: string } | null => {
        if (!control.parent) {
            return null;
        }
        if (condition()) {
            return validator(control);
        }
        return null;
    };
}
